import React from "react"
import TagSelectFilter from "./TagSelectFilter"
import UserSelectFilter from "./UserSelectFilter"
import ThemeProviderWrapper from "./ThemeProviderWrapper"
import { styled } from "@mui/material/styles"
import { css } from "@emotion/react"
import {
  Button as MuiButton,
  Select as MuiSelect,
  MenuItem,
  InputLabel,
} from "@mui/material"

const HeaderContainer = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`

const SampleReviewFilterContainer = styled("div")`
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
`

const SelectContainer = styled("div")`
  flex-grow: 0;
  margin-right: 20px;
`

const Button = styled(MuiButton)`
  align-self: flex-end;
  margin-bottom: 5px;
`

const Select = styled(MuiSelect)`
  margin: 3px;
`

const filterByStateOptions = [
  "Reviewable",
  "Needs more info",
  "Rejected",
  "With no name",
  "All",
]

const sortByOptions = ["Oldest", "Newest"]

export default class SampleReviewFilter extends React.Component {
  constructor(props) {
    super(props)
    const selectedUsersToExclude = props.userSlugsToExclude
      ? props.allSampleUploaders.filter((user) =>
          props.userSlugsToExclude.includes(user.slug)
        )
      : []

    const selectedUsersToInclude = props.userSlugsToInclude
      ? props.allSampleUploaders.filter((user) =>
          props.userSlugsToInclude.includes(user.slug)
        )
      : []

    this.state = {
      stateFilter: props.showFilter || filterByStateOptions[0],
      sortBy: props.order || sortByOptions[0],
      tagsToFilter: props.tagsToFilter || [],
      tagsToFilterOptions: props.tagsToFilter.map((tag) => ({
        value: tag,
        label: tag,
      })),
      userSlugsToExclude: props.userSlugsToExclude || [],
      userSlugsToExcludeOptions: selectedUsersToExclude.map((user) => ({
        value: user.slug,
        label: user.display_name,
      })),
      userSlugsToInclude: props.userSlugsToInclude || [],
      userSlugsToIncludeOptions: selectedUsersToInclude.map((user) => ({
        value: user.slug,
        label: user.display_name,
      })),
    }
  }

  handleSubmit = () => {
    const {
      stateFilter,
      sortBy,
      userSlugsToExclude,
      userSlugsToInclude,
      tagsToFilter,
    } = this.state

    const baseURL = `${window.location.origin}/samples/review_v2`

    const params = new URLSearchParams({
      stateFilter: stateFilter,
      sortBy: sortBy,
      userSlugsToExclude: userSlugsToExclude.join(","),
      userSlugsToInclude: userSlugsToInclude.join(","),
      tagsToFilter: tagsToFilter.join(","),
    })

    window.location.href = `${baseURL}?${params}`
  }

  handleSelectChange = (event) => {
    const { name, value } = event.target
    this.setState({ [name]: value })
  }

  handleSelectOptionsChange = (selectedOptionsArray, event) => {
    const selectedOptions = selectedOptionsArray
      ? selectedOptionsArray.map((optionObject) => optionObject.value)
      : []
    const selectName = event.name
    this.setState({
      [selectName]: selectedOptions,
      [`${selectName}Options`]: selectedOptionsArray,
    })
  }

  render() {
    const { tagOptions, allSampleUploaders, reviewableSamplesCount } =
      this.props
    const {
      sortBy,
      stateFilter,
      tagsToFilterOptions,
      userSlugsToExcludeOptions,
      userSlugsToIncludeOptions,
    } = this.state

    let heightOfTagPanel = window.innerHeight - 370
    if (window.innerHeight < 660) {
      heightOfTagPanel = 320
    }

    return (
      <ThemeProviderWrapper>
        <HeaderContainer>
          <h2 className="black-weight">Review</h2>
          <p className="flow-text">
            &nbsp; {reviewableSamplesCount} samples are awaiting review.
          </p>
        </HeaderContainer>
        <SampleReviewFilterContainer>
          <SelectContainer>
            {/* NOTE: Duplicate TTS announcements */}
            <InputLabel id="filter-select-label">Filter By</InputLabel>
            <Select
              labelId="filter-select-label"
              id="filter-select"
              onChange={this.handleSelectChange}
              name="stateFilter"
              value={stateFilter}
              size="small"
              aria-label="Filter By"
              role="select"
            >
              {filterByStateOptions.map((filterByStateOption) => {
                return (
                  <MenuItem
                    key={filterByStateOption}
                    value={filterByStateOption}
                  >
                    {filterByStateOption}
                  </MenuItem>
                )
              })}
            </Select>
          </SelectContainer>
          <SelectContainer>
            {/* NOTE: Duplicate TTS announcements */}
            <InputLabel id="sort-select-label">Sort By</InputLabel>
            <Select
              labelId="sort-select-label"
              id="sort-select"
              onChange={this.handleSelectChange}
              name="sortBy"
              value={sortBy}
              size="small"
              aria-label="Sort By"
              role="select"
            >
              {sortByOptions.map((sortByOption) => {
                return (
                  <MenuItem key={sortByOption} value={sortByOption}>
                    {sortByOption}
                  </MenuItem>
                )
              })}
            </Select>
          </SelectContainer>
          <SelectContainer
            css={css`
              min-width: 300px;
            `}
          >
            <InputLabel id="filter-select-label">Users to Exclude</InputLabel>
            <UserSelectFilter
              handleSelectChange={this.handleSelectOptionsChange}
              userSlugsToExcludeOptions={userSlugsToExcludeOptions}
              allSampleUploaders={allSampleUploaders}
              filterName="userSlugsToExclude"
              ariaLabel="Users to Exclude"
              role="combobox"
            />
          </SelectContainer>
          <SelectContainer
            css={css`
              min-width: 300px;
            `}
          >
            <InputLabel id="filter-select-label">Users to Include</InputLabel>
            <UserSelectFilter
              handleSelectChange={this.handleSelectOptionsChange}
              userSlugsToExcludeOptions={userSlugsToIncludeOptions}
              allSampleUploaders={allSampleUploaders}
              filterName="userSlugsToInclude"
              ariaLabel="Users to Include"
              role="combobox"
            />
          </SelectContainer>
          <SelectContainer
            css={css`
              width: 400px;
            `}
          >
            <InputLabel id="filter-select-label">Tags to Include</InputLabel>
            <TagSelectFilter
              tagOptions={tagOptions}
              heightOfTagPanel={heightOfTagPanel}
              handleSelectChange={this.handleSelectOptionsChange}
              name={"tagsToFilter"}
              selectedOptions={tagsToFilterOptions}
              aria-label="Tags to Include"
              role="combobox"
            />
          </SelectContainer>
          <Button onClick={this.handleSubmit} variant="contained" aria-label="Update filter">
            Update
          </Button>
        </SampleReviewFilterContainer>
      </ThemeProviderWrapper>
    )
  }
}
